import _ from 'lodash';

export const getUniqueValues = (data, key) => [...new Set(data.map(item => _.get(item, key)))];

export const getNestedValue = (item, path) => _.get(item, path);

export const getRange = (data, path) => {
  const values = data.map(item => getNestedValue(item, path)).filter(_.isNumber);
  return [_.min(values), _.max(values)];
};

export const applyCategoryOrBooleanFilter = (itemValue, filterValue) => {
  if (Array.isArray(filterValue)) {
    return filterValue.includes(itemValue);
  } else {
    return filterValue === itemValue;
  }
};

export const applyNumberRangeFilter = (itemValue, filterValue) => {
  if (_.isPlainObject(filterValue) && _.has(filterValue, 'min')) {
    return itemValue >= filterValue.min && itemValue <= filterValue.max;
  }
  return true;
};

export const applySearchFilter = (data, searchText) => {
  if (!searchText) return data;

  const lowerCaseSearchText = searchText.toLowerCase();
  return data.filter(item => {
    const name = _.get(item, 'name', '');
    return name.toLowerCase().includes(lowerCaseSearchText);
  });
};

export const applyAllFilters = (data, filters, configs) => {
  let filteredData = data;
  const typeMap = _.fromPairs(configs.map(config => [config.key, config.type]));

  _.forEach(filters, (filterValue, keyPath) => {
    if (filterValue === undefined || filterValue === null) return;

    if (typeMap[keyPath] === 'search' && _.isString(filterValue)) {
      filteredData = applySearchFilter(filteredData, filterValue);
    } else {
      filteredData = filteredData.filter(item => {
        const itemValue = _.get(item, keyPath);

        if (_.isPlainObject(filterValue) && _.has(filterValue, 'min')) {
          return applyNumberRangeFilter(itemValue, filterValue);
        } else {
          return applyCategoryOrBooleanFilter(itemValue, filterValue);
        }
      });
    }
  });

  return filteredData;
};

export const sortByInUse = (portfolioList) => {
  portfolioList.sort((a, b) => {
    const aStarred = _.get(a, '_user.in_use', false) ? 1 : 0;
    const bStarred = _.get(b, '_user.in_use', false) ? 1 : 0;
    return bStarred - aStarred || a?.name.localeCompare(b?.name);
  });
};